export default __webpack_public_path__ + "static/media/donation-nygh.39a0db26.png";